import React from 'react';

const ProfilePage: React.FC = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h1>내 정보</h1>
      <p>사용자 정보를 확인하고 수정할 수 있는 페이지입니다.</p>
      <p>추후 구현 예정입니다.</p>
    </div>
  );
};

export default ProfilePage;